import { useAtomValue, useSetAtom } from 'jotai';
import { FC } from 'react';

import { FloatingDraggable } from '@/components/floating-draggable/floating-draggable';
import { openToItemAtom } from '@/features/developer-tools/state/dev-tools-panel.state';
import { displayTemplatePreviewStorageAtom } from '@/state/display-template-preview.state';
import { Button } from '@/ux-common/components/button/button';

export const DisplayTemplatePreviewButton: FC = () => {
  const previewStorage = useAtomValue(displayTemplatePreviewStorageAtom);
  const openToItem = useSetAtom(openToItemAtom);

  // Only show button if there's a preview loaded
  if (!previewStorage?.jsonContent) return null;

  return (
    <FloatingDraggable
      storageKey="display-template-preview-button-position"
      defaultPosition={{
        right: 90,
        bottom: 25,
      }}
    >
      <Button
        className="btn btn-default btn-sm animate-pulse-scale hover:animate-none shadow-lg hover:shadow-xl ring-2 ring-[#FF1493]/100 hover:ring-[#FF1493]/20 transition-all duration-200 hover:scale-105"
        style={{ backgroundColor: '#FF1493', animationDuration: '2s' }}
        onClick={() => {
          openToItem('display-template-preview');
        }}
        aria-label="Open display template preview"
      >
        <span className="text-white font-semibold text-xs whitespace-nowrap">Previewing JSON</span>
      </Button>
    </FloatingDraggable>
  );
};
